import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Comment, Document, EventNew } from '../../../../_shared/model';
import { WaitingQueueItem } from '../../../../_shared/model/schedule/WaitingQueueItem.model';
import { HelperService } from '../../../../_shared/services';
import { HttpClientService } from '../../../../_shared/services/http-client.service';

@Injectable({
    providedIn: 'root',
})
export class WaitingQueueService {
    constructor(
        private httpClient: HttpClientService,
        private helper: HelperService,
    ) {}

    //findWaitingQueueItems()
    public findWaitingQueueItems(contractorId: number): Observable<WaitingQueueItem[]> {
        return this.httpClient.get(this.helper.getApiUrl() + `/waitingqueue/contractors/${contractorId}`);
    }

    //getCaseComments()
    public getCaseComments(buid: string | number, caseid: string): Observable<Comment[]> {
        return this.httpClient.get(this.helper.getAssistanceUrl() + `/bs/${buid}/cases/${this.helper.replaceSlahsForDolar(caseid)}/comments`).pipe(
            map(el => {
                return _.get(el, 'comments', undefined);
            }),
        );
    }

    //getCaseDocuments()
    public getCaseDocuments(bsid: string | number, caseid: string): Observable<Document[]> {
        return this.httpClient.get(this.helper.getAssistanceUrl() + `/bs/${bsid}/cases/${this.helper.replaceSlahsForDolar(caseid)}/documents`).pipe(
            map(el => {
                if (_.isNil(el.documents)) {
                    return [];
                }
                return el.documents.map(el => new Document().deserialize(el));
            }),
        );
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public makePrereservationFromWQItem(wqid: number, data: EventNew): Observable<any> {
        return this.httpClient.post(this.helper.getApiUrl() + `/prereservation/wq/${wqid}`, data);
    }
}
